// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__p6raP","mounted":"styles_mounted__rYZWG","right":"styles_right__SJh0K"};